export default "/profile/images/telegram.svg?2a104c316784e862d0b79b6fca828673";